export enum StampCardSlotTypeEnum {
  PREMIUM = 2,
  STANDARD = 1,
}

export enum StampCardItemStatus {
  locked = 'locked',
  unlocked = 'unlocked',
  claimable = 'claimable',
  claimed = 'claimed',
  missed = 'missed',
}

export interface StampCardItemModel {
  status?: StampCardItemStatus;
  itemId: string;
  itemTypeId: number;
  slotId: string;
  slotTypeId: StampCardSlotTypeEnum;
  type: number;
  displayName: string;
  imageUrl: string;
  quantity: number;
  orderNumber: number;
  slotTimer: number;
  id: string;
  description: string;
  unlockAt?: Date | null;
  isAfterUnlocked?: boolean;
  isPrizeProgressBar?: boolean;
}

export interface StampCardSlotModel {
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  stampCardId: number;
  slotId: string;
  slotTypeId: StampCardSlotTypeEnum;
  minPurchaseAmount: number | null;
  slotTimer: number;
  items: StampCardItemModel[];
}

export interface StampListModel {
  premium: StampCardSlotModel[];
  standard: StampCardSlotModel[];
}
